import TooltipIcon from '../customTooltip';
import { useDialog } from 'src/customHooks/useDialog';
import React, { useEffect, useState } from 'react';
import './style.scss';

interface IDrawerProps {
    onClose: Function;
    actionButton?: {
        text: string;
        showEditButton: boolean;
        onClickHandler: Function;
    };
    tooltipText?: string;
    alterButton?: {
        text: string;
        showAlterButton: boolean;
        onClickHandler: Function;
    };
    title?: React.ReactNode;
}

const Drawer: React.FC<IDrawerProps> = ({
    actionButton,
    onClose,
    tooltipText,
    children,
    alterButton,
    title,
}) => {
    const [isClosed, setIsClose] = useState<boolean>(false);

    function closeHandler() {
        const DELAY = 10;
        setIsClose(true);
        setTimeout(() => onClose(), DELAY);
    }

    function actionButtonHandler() {
        const DELAY = 10;
        setIsClose(true);
        setTimeout(() => actionButton?.onClickHandler(), DELAY);
    }
    const { dialogRef, closeDialogRef, openDialogRef } = useDialog();

    useEffect(() => {
        const openClose = async () => {
            if (!isClosed) openDialogRef();
            else await closeDialogRef();
        };
        openClose();
    }, [isClosed]);

    return (
        <>
            <div
                className='drawer-background'
                onClick={() => closeHandler()}
            ></div>
            <dialog
                ref={dialogRef}
                className='c-interaction-layer  js-interaction-layer'
                aria-hidden={isClosed ? 'true' : 'false'}
                id='interaction-layer'
            >
                <div className='js-interaction-layer-close' tabIndex={-1}></div>
                <div className='c-interaction-layer__wrapper' role='dialog'>
                    <header className='c-interaction-layer__header'>
                        {title && (
                            <h2 className='c-interaction-layer-title'>
                                {title}
                            </h2>
                        )}
                        <button
                            className='c-interaction-layer__close-btn  js-interaction-layer-close  js-interaction-layer-autofocus'
                            type='button'
                            aria-label='Close'
                            onClick={() => closeHandler()}
                        ></button>
                    </header>
                    <div
                        className='c-interaction-layer__content'
                        role='document'
                    >
                        {children}
                    </div>
                    <div className='c-interaction-layer__footer'>
                        <div className='tooltipIcon'>
                            {tooltipText ? (
                                <TooltipIcon
                                    text={tooltipText}
                                    position='bottom'
                                ></TooltipIcon>
                            ) : null}
                        </div>
                        <div className='very-right-item'>
                            {actionButton ? (
                                <button
                                    className='c-btn--secondary c-btn c-btn--small'
                                    aria-label='Confirm'
                                    onClick={() => actionButtonHandler()}
                                    disabled={!actionButton.showEditButton}
                                >
                                    <span className='c-btn__text'>
                                        {actionButton.text}
                                    </span>
                                </button>
                            ) : null}
                            {alterButton ? (
                                <button
                                    className='c-btn--secondary c-btn c-btn--small'
                                    aria-label='Confirm'
                                    onClick={() => alterButton.onClickHandler()}
                                    disabled={!alterButton.showAlterButton}
                                >
                                    <span className='c-btn__text'>
                                        {alterButton.text}
                                    </span>
                                </button>
                            ) : null}
                        </div>
                    </div>
                </div>
            </dialog>
        </>
    );
};

export default Drawer;
